<template>
    <div class="event-component__inner">
        <div class="event-component__header">
            <div class="event-component__headline">{{ dictionary.EventsHeadline }}</div>
            <ul class="filter-list">
                <li>
                    <select v-model="tag">
                        <option v-for="tagItem in tags" :key="tagItem.Id" :value="tagItem.Key">{{ tagItem.Name }}</option>
                    </select>
                </li>
            </ul>
        </div>
        <ul class="event-component__list">
            <li class="event-component__list-item" v-for="event in events" :key="event.Headline">
                <a :href="event.Url">
                    <div class="event-component__list-image">
                        <ResponsiveImage v-if="event.HasEventImage" :imageModel="event.ImageForVue" />
                    </div>
                </a>
                <a :href="event.Url">
                    <div class="event__headline">{{ event.Headline }}</div>
                </a>
                <div class="event">
                    <div class="event__footer">
                        <a :href="event.Url">
                            <div class="event__date">{{ event.StartDate }} <span v-if="event.HasEndDate">- {{ event.EndDate }}</span></div>
                            <div class="event__tag" v-for="tag in event.Tags">{{ tag }}</div>
                        </a>
                    </div>
                    <div v-if="!event.IsFree" class="event__footer-ticket">
                        <div class="event__ticket"><a :href="event.TicketsLink">{{ dictionary.BuyTicket }}</a></div>
                    </div>
                </div>
            </li>
        </ul>

        <div class="event-component__footer">
            <div class="event-component__load-more" v-show="hasMoreEvents">
                <a @click="getNextPage" :disabled="isLoading">{{
                    dictionary.EventsLoadMore
                }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";

const serviceUrl = "/umbraco/api/eventsApi/getEvents",
    defaultTag = "All",
    defaultOrder = 0;

export default {
    name: "events",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            eventsPageId: null,
            dictionary: [],
            tags: [],
            events: [],
            pageSize: 3,
            page: 1,
            totalEvents: 0,
            isLoading: false,
            hasLoadedInitials: false,
            isResetting: false
        };
    },
    mixins: [
        bindRoute({
            tag: defaultTag,
            orderBy: defaultOrder
        }),
    ],
    watch: {
        tag: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        orderBy: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        }
    },
    mounted() {
        this.eventsPageId = parseInt(this.$parent.eventsPageId);
        this.pageSize = parseInt(this.$parent.pageSize);

        this.$router.isReady().then(() => {
            this.getInitialEvents();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged();
                }
            }
        },
        getEvents(amountToSkip, pageSize) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                eventsPageId: vm.eventsPageId,
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize
            };

            if (vm.tag != defaultTag) {
                object.tag = vm.tag;
            }

            if (vm.orderBy != defaultOrder) {
                object.orderBy = vm.orderBy;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    vm.dictionary = data.Dictionaries;
                    vm.tags = data.Facets.Tags;

                    vm.tags.unshift({
                        Name:vm.dictionary.EventsAll,
                        Id:'all',
                        Key:'All'
                    })

                    vm.events.push(...data.Items);
                    vm.totalEvents = data.TotalItems;
                    vm.hasLoadedInitials = true;
                    vm.toggleSpinner(false);
                    vm.isResetting = false;
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getEvents(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialEvents() {
            let initialPageSize = this.pageSize;
            if (this.tag != defaultTag) {
                initialPageSize = this.pageSize * this.page;
            }
            this.getEvents(0, initialPageSize);
        },
        filterChanged() {
            this.events = [];
            this.totalEvents = 0;
            this.page = 1;
            this.getEvents(0, this.pageSize);
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.events = [];
            vm.totalEvents = 0;
            vm.page = 1;
            vm.tag = defaultTag;

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getInitialEvents();
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreEvents() {
            return (
                this.totalEvents !== 0 &&
                this.events.length < this.totalEvents
            );
        },
        hasFilterApplied() {
            return this.tag != defaultTag;
        }
    },
};
</script>